<template>
	<div id="dashboard-quotations" class="dashboard-subtemplate">
		
		<div class="requested-quotations" v-if="requestedSurveys.length > 0">	
			<div class="dash__section-title dash__section-title--quotes">Requested Quotations</div>
			<QuotationRequestedPost 
				v-for="(surveyData, i) in requestedSurveys"
				v-if="i < reqQuotesRenderGetSize" 
				:key="surveyData.survey.quoteReference" 
				:surveyData="surveyData"
				v-on:openCloseToggle="toggleMoreInfo"
				:toggled="toggled"
				:isAdmin="isAdmin"
			/>
			<!-- show more from store -->
			<div v-if="reqQuotesRenderGetSize < requestedSurveys.length">
				<button class="btn btn-small" @click="reqQuotesRenderGetSize += reqQuotesIncreaseBy">Load more</button>
			</div>
		
		</div>
		
		<div class="open-quotations" v-if="openSurveys.length > 0">	
			<div class="dash__section-title dash__section-title--quotes">Open Quotations</div>
						
			<QuotationOpenPost 
				v-for="(surveyData, i) in openSurveys"
				v-if="i < openQuotesRenderGetSize" 
				:key="surveyData.survey.quoteReference" 
				:surveyData="surveyData"
				v-on:openCloseToggle="toggleMoreInfo"
				:toggled="toggled"
				:isAdmin="isAdmin"
			/>	

			<div v-if="openQuotesRenderGetSize < openSurveys.length">
				<button class="btn btn-small" @click="openQuotesRenderGetSize += openQuotesIncreaseBy">Load more</button>
			</div>
		</div>

		<div v-if="openSurveys.length == 0 && requestedSurveys.length == 0">
			There are no open or requested surveys to show.
		</div>
	</div>
</template>

<script>

// import CreateProgressBar from '../common/Create/CreateProgressBar';
// import LoginPanel from '../common/Login/LoginPanel';
import QuotationRequestedPost from '../common/Dashboard/QuotationRequestedPost';
import QuotationOpenPost from '../common/Dashboard/QuotationOpenPost';

export default {
	components : {
		QuotationRequestedPost,
		QuotationOpenPost
	},
	data(){
		return {
			toggled : "",
			reqQuotesRenderGetSize : 50,
			reqQuotesIncreaseBy : 5,
			openQuotesRenderGetSize : 50,
			openQuotesIncreaseBy : 5
		}
	},
	computed : {
		requestedSurveys(){
			return this.$store.getters.getRequestedSurveys
		},
		openSurveys(){
			return this.$store.getters.getOpenSurveys
		},
		userInfo(){
			return this.$store.getters.getUserInfo
		},
		isAdmin(){
			return this.userInfo.role === 'admin'
		}
	},
	methods : {
		toggleMoreInfo(quoteReference){
		
			if(this.toggled === quoteReference){
				this.toggled = '';
			} else {
				this.toggled = quoteReference
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/pages/DashboardQuotations.vue